import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DedupeState } from '../../duplikit/dedupe-state/dedupe-state';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class DuplikitSyncService {
  syncCheckTimer: Subscription;
  syncCheck = {
    isSyncing: false,
    data: {}
  };

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService
  ) {
  }

  runSyncCheck() {
    if (this.syncCheckTimer) {
      this.syncCheckTimer.unsubscribe();
    }

    this.syncCheckTimer = timer(2000, 10000).subscribe(() => {
      this.getSyncCheck().subscribe((res) => {
        this.syncCheck = res;
      });
    });
  }

  getSyncCheck(): Observable<any> {
    return this.http.get<boolean>(`${environment.duplikitUrl}/DedupeState/corpIsSyncing`);
  }

  getEntityDedupeState(fullEntityName: string): Observable<DedupeState> {
    const entity = this.utilsService.getEntityLabel(fullEntityName).toLowerCase();
    return this.http.get<DedupeState>(`${environment.duplikitUrl}/${entity}/dedupeState`);
  }

  getEntitySyncedRecordCount(fullEntityName: string): Observable<number> {
    return this.http.get<number>(`${environment.duplikitUrl}/${fullEntityName}/syncedCount`);
  }

  getEntityDuplicateCount(fullEntityName: string): Observable<number> {
    return this.http.get<number>(`${environment.duplikitUrl}/${fullEntityName}/duplicateCount`);
  }


  entityIsSyncing(entity: string = null): boolean {
    if (!entity) {
      return this.syncCheck.isSyncing;
    }

    return this.syncCheck.data[`isSyncing${entity}s`];
  }

  setEntitySyncStatus(entity: string, status: boolean) {
    this.runSyncCheck();
    this.syncCheck.isSyncing = status;
    this.syncCheck.data[`isSyncing${entity}s`] = status;
  }

  stopSyncCheck() {
    if (this.syncCheckTimer) {
      this.syncCheckTimer.unsubscribe();
    }
  }

}
